(ns app.front.view.project.bill-events
  (:require
    [app.front.entities :as entities]
    [app.front.process :as process]
    [re-frame.core-instrumented :as rf]))

(defn- bill-id-in-invoice-trail? [bill-id db]
  (contains? (get-in db [::bill-reversal :trail-expanded]) bill-id))

(rf/reg-event-db ::toggle-invoice-trail
  (fn [db [_ bill-id]]
    (if (bill-id-in-invoice-trail? bill-id db)
      (update-in db [::bill-reversal :trail-expanded] disj bill-id)
      (update-in db [::bill-reversal :trail-expanded] (fnil conj #{}) bill-id))))

(rf/reg-sub ::invoice-trail-expanded?
  (fn [db [_ bill-id]]
    (bill-id-in-invoice-trail? bill-id db)))

(rf/reg-event-fx ::open-reversal-modal
  (fn [{:keys [db]} [_ workspace-id bill-id schedule-id]]
    {:db       (-> db
                   (assoc-in [::bill-reversal :modal :open-for-bill] bill-id)
                   (assoc-in [::bill-reversal :modal :selected-method] nil)
                   (assoc-in [::bill-reversal :modal :reason] "")
                   (assoc-in [::bill-reversal :modal :submitting?] false))
     :dispatch [:app.front.view.fee.list/fetch-fee-schedule-data workspace-id schedule-id]}))

(rf/reg-event-db ::close-reversal-modal
  (fn [db _]
    (update db ::bill-reversal dissoc :modal)))

(rf/reg-event-db ::set-selected-reversal-method
  (fn [db [_ method]]
    (assoc-in db [::bill-reversal :modal :selected-method] method)))

(rf/reg-event-db ::set-reversal-reason
  (fn [db [_ reason]]
    (assoc-in db [::bill-reversal :modal :reason] reason)))

(rf/reg-event-fx ::submit-reversal
  (fn [{:keys [db]} [_ bill-id]]
    (let [method-id  (get-in db [::bill-reversal :modal :selected-method :method-id])
          reason     (get-in db [::bill-reversal :modal :reason])
          bill       (get-in db [::entities/entity-db bill-id])
          fsm-target (:entity/parent bill)]
      {:db       (assoc-in db [::bill-reversal :modal :submitting?] true)
       :dispatch [::process/signal
                  fsm-target
                  [:process.signal/reverse-bill
                   {:bill-id            bill-id
                    :reversal-method-id method-id
                    :reason             reason}]
                  {:notify   {:success :bill/reversal-draft-created}
                   :on-done  [::reversal-done]
                   :on-error [::reversal-failure]}]})))

(rf/reg-event-fx ::reversal-failure
  [(rf/inject-cofx :tr)]
  (fn [{:keys [db]} _]
    {:db       (assoc-in db [::bill-reversal :modal :submitting?] false)
     :dispatch [:notifications/add :toast :error :failure
                :error/bill-reversal-error]}))

(rf/reg-event-db ::reversal-done
  (fn [db _]
    (update db ::bill-reversal dissoc :modal)))
